import _ from 'underscore';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { SwitchTransition } from 'react-transition-group';

import Animation from 'components/Animation';
import EmptyMessage from 'components/EmptyMessage';
import Section from 'components/Section';
import Slider from 'components/sliders/OffsetSlider';

import CommonPropTypes from 'utils/propTypes/common';

const SlideSection = ({
	theme,
	items,
	getSwiper,
	slidesPerView,
	emptyMessageText,
	sliderParams,
	children,
	markupBlocks,
	...props
}) => {
	const [swiper, setSwiper] = useState(null);

	const keys = useMemo(
		() =>
			_(items)
				.map((item) => item._id || item.name)
				.join(),
		[items]
	);

	useEffect(() => {
		if (swiper && !swiper.destroyed) {
			swiper.slideTo(0);
		}
	}, [keys]);

	const getSwiperInstance = useCallback(
		(swiperInstance) => {
			setSwiper(swiperInstance);

			getSwiper?.(swiperInstance);
		},
		[getSwiper]
	);

	return (
		<Section markupBlocks={markupBlocks} {...props}>
			<SwitchTransition>
				<Animation
					show
					key={keys}
					addEndListener={(node, done) =>
						node.addEventListener('transitionend', done, false)
					}
					timeout={100}
					animation="fade"
				>
					{children.length ? (
						<Slider
							withNavigation
							getSwiper={getSwiperInstance}
							theme={theme}
							params={sliderParams}
							slidesPerView={slidesPerView}
							paginationMarkupAttributes={markupBlocks.pagination}
						>
							{children}
						</Slider>
					) : (
						<EmptyMessage text={emptyMessageText} />
					)}
				</Animation>
			</SwitchTransition>
		</Section>
	);
};

SlideSection.propTypes = {
	items: PropTypes.array,
	title: PropTypes.string,
	renderControls: PropTypes.func,
	getSwiper: PropTypes.func,
	theme: PropTypes.string,
	emptyMessageText: PropTypes.string,
	moreControl: CommonPropTypes.link,
	sliderParams: PropTypes.object,
	children: PropTypes.node,
	slidesPerView: PropTypes.number,
	markupBlocks: PropTypes.object
};

SlideSection.defaultProps = {
	markupBlocks: {}
};

export default SlideSection;
